<div class="stsdocs-page-header">
    <h2 class="stsdocs-page-header-title">Downloads</h2>
</div>
<div class="stsdocs-page-body">
    <div fxLayout fxLayoutAlign="center center" class="stsdocs-tabs-header">
        <mat-tab-group [(selectedIndex)]="selectedIndex" (selectedTabChange)="selectedTabChange($event)" animationDuration="0ms" mat-align-tabs="center" mat-stretch-tabs>
            <mat-tab label="ImgSigner Application"></mat-tab>
            <mat-tab label=".NET Library"></mat-tab>
            <mat-tab label="Node.js Library"></mat-tab>
            <mat-tab label="Python Library"></mat-tab>
        </mat-tab-group>
    </div>
    <ng-template #elseBlock>
        <h4 class="bigpad">--</h4>
    </ng-template>
    <ng-template #loadingBlock>
        <mat-spinner [diameter]="200" style="margin:0 auto; margin-top:20vh;"></mat-spinner>
    </ng-template>

    <div [ngSwitch]="selectedIndex" class="stsdocs-tabs-body">

        <!-- ImgSigner (Index 0) -->
        <div *ngSwitchCase="0">
            <div *ngIf="!loading && clients[0] && clients[0].download; else loadingBlock" class="stsdocs-tabs-body-content">
                <h1 class="smallpad">ImgSigner Downloads</h1>
                <h2 class="medpad">Latest Version ({{clients[0].latest.version}})</h2>
                <a *ngIf="clients[0].download.latest" [href]="clients[0].download.latest.url" target="_blank">
                    <h4 class="bigpad">{{clients[0].download.latest.name}}</h4>
                </a>

                <h2 class="medpad">Prior Versions</h2>
                <div *ngIf="clients[0].download.prior && clients[0].download.prior.length > 0; else elseBlock">
                    <div *ngFor="let link of clients[0].download.prior">
                        <a [href]="link.url" target="_blank"><h4 class="bigpad">{{link.name}}</h4></a>
                    </div>
                </div>
            </div>
        </div>

        <!-- .NET (Index 1) -->
        <div *ngSwitchCase="1">
            <div *ngIf="!loading && clients[1] && clients[1].download; else loadingBlock" class="stsdocs-tabs-body-content">
                <h1 class="smallpad">.NET Downloads</h1>
                <h2 class="medpad">Latest Version ({{clients[1].latest.version}})</h2>

                <a *ngIf="clients[1].download.latest" [href]="clients[1].download.latest.url" target="_blank">
                    <h4 class="bigpad">{{clients[1].download.latest.name}}</h4>
                </a>

                <h2 class="medpad">Prior Versions</h2>
                <div *ngIf="clients[1].download.prior && clients[1].download.prior.length > 0; else elseBlock">
                    <div *ngFor="let link of clients[1].download.prior">
                        <a [href]="link.url" target="_blank"><h4 class="bigpad">{{link.name}}</h4></a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Node.js (Index 2) -->
        <div *ngSwitchCase="2">
            <div *ngIf="!loading && clients[2] && clients[2].download; else loadingBlock" class="stsdocs-tabs-body-content">
                <h1 class="smallpad">Node.js Downloads</h1>
                <h2 class="medpad">Latest Version ({{clients[2].latest.version}})</h2>

                <a *ngIf="clients[2].download.latest" [href]="clients[2].download.latest.url" target="_blank">
                    <h4 class="bigpad">{{clients[2].download.latest.name}}</h4>
                </a>

                <h2 class="medpad">Prior Versions</h2>
                <div *ngIf="clients[2].download.prior && clients[2].download.prior.length > 0; else elseBlock">
                    <div *ngFor="let link of clients[2].download.prior">
                        <a [href]="link.url" target="_blank"><h4 class="bigpad">{{link.name}}</h4></a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Python (Index 3) -->
        <div *ngSwitchCase="3">
            <div *ngIf="!loading && clients[3] && clients[3].download; else loadingBlock" class="stsdocs-tabs-body-content">
                <h1 class="smallpad">Python Downloads</h1>
                <h2 class="medpad">Latest Version ({{clients[3].latest.version}})</h2>

                <a *ngIf="clients[3].download.latest" [href]="clients[3].download.latest.url" target="_blank">
                    <h4 class="bigpad">{{clients[3].download.latest.name}}</h4>
                </a>

                <h2 class="medpad">Prior Versions</h2>
                <div *ngIf="clients[3].download.prior && clients[3].download.prior.length > 0; else elseBlock">
                    <div *ngFor="let link of clients[3].download.prior">
                        <a [href]="link.url" target="_blank"><h4 class="bigpad">{{link.name}}</h4></a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Default case -->
        <div *ngSwitchDefault>
            <div *ngIf="!loading && clients[0] && clients[0].download; else loadingBlock" class="stsdocs-tabs-body-content">
                <h1 class="smallpad">ImgSigner Downloads</h1>
                <h2 class="medpad">Latest Version ({{clients[0].latest.version}})</h2>

                <a *ngIf="clients[0].download.latest" [href]="clients[0].download.latest.url" target="_blank">
                    <h4 class="bigpad">{{clients[0].download.latest.name}}</h4>
                </a>

                <h2 class="medpad">Prior Versions</h2>
                <div *ngIf="clients[0].download.prior && clients[0].download.prior.length > 0; else elseBlock">
                    <div *ngFor="let link of clients[0].download.prior">
                        <a [href]="link.url" target="_blank"><h4 class="bigpad">{{link.name}}</h4></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
